import React from 'react';
import cn from 'classnames';
import { ChevronBackMIcon } from '@alfalab/icons-glyph/ChevronBackMIcon';
import { ChevronForwardMIcon } from '@alfalab/icons-glyph/ChevronForwardMIcon';
import { DefaultView } from './components/default-view/index.js';
import { PerPageView } from './components/per-page-view/index.js';
import { Tag } from './components/tag/index.js';
import 'tslib';
import '../../tag/esm/desktop';

var styles = {"component":"pagination__component_rq2ri","defaultView":"pagination__defaultView_rq2ri"};
require('./index.css');

var Pagination = function (_a) {
    var _b = _a.currentPageIndex, currentPageIndex = _b === void 0 ? 0 : _b, pagesCount = _a.pagesCount, className = _a.className, _c = _a.sidePadding, sidePadding = _c === void 0 ? 1 : _c, _d = _a.activePadding, activePadding = _d === void 0 ? 2 : _d, _e = _a.hideArrows, hideArrows = _e === void 0 ? true : _e, _f = _a.view, view = _f === void 0 ? 'default' : _f, _g = _a.onPageChange, onPageChange = _g === void 0 ? function () { return null; } : _g, dataTestId = _a.dataTestId;
    var handlePageClick = function (pageIndex) {
        onPageChange(pageIndex);
    };
    var handleNextPageClick = function () {
        handlePageClick(Math.min(pagesCount - 1, currentPageIndex + 1));
    };
    var handlePrevPageClick = function () {
        handlePageClick(Math.max(0, currentPageIndex - 1));
    };
    var shouldRenderPrevArrow = view === 'per-page' || !hideArrows || currentPageIndex > 0;
    var shouldRenderNextArrow = view === 'per-page' || !hideArrows || currentPageIndex < pagesCount - 1;
    var viewClassName = view === 'default' ? 'defaultView' : view;
    return (React.createElement("div", { className: cn(styles.component, className, styles[viewClassName]), "data-test-id": dataTestId },
        shouldRenderPrevArrow && (React.createElement(Tag, { className: styles.arrow, disabled: currentPageIndex <= 0, onClick: handlePrevPageClick, rightAddons: React.createElement(ChevronBackMIcon, { width: 16, height: 16 }) })),
        view === 'default' && (React.createElement(DefaultView, { activePadding: activePadding, sidePadding: sidePadding, currentPageIndex: currentPageIndex, pagesCount: pagesCount, onPageChange: handlePageClick })),
        view === 'per-page' && (React.createElement(PerPageView, { currentPageIndex: currentPageIndex, pagesCount: pagesCount })),
        shouldRenderNextArrow && (React.createElement(Tag, { className: styles.arrow, disabled: currentPageIndex >= pagesCount - 1, onClick: handleNextPageClick, rightAddons: React.createElement(ChevronForwardMIcon, { width: 16, height: 16 }) }))));
};

export { Pagination };
